import { render, staticRenderFns } from "./ContaLogin.vue?vue&type=template&id=51a30b12"
import script from "./ContaLogin.vue?vue&type=script&lang=js"
export * from "./ContaLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports